<div class="reset-container">
  <p>Set a schedule.</p>
  <acl-ngx-button label=Clear [compact]="true" variant="static" (click)="resetDaypart()">
  </acl-ngx-button>
</div>
<div class="daypart-grid">
  <table #grid class="table-grid" cellspacing="0" (mousemove)="applySelectionColor($event)">
    <tbody>
      <tr class="column-headers">
        <td></td>
        <td *ngFor="let day of dayLabel; let k = index" (click)="selectWholeColumn(k)">
          <span>{{day | uppercase}}</span>
        </td>
      </tr>
      <tr id="row-{{i}}" *ngFor="let hour of hourLabel; let i = index">
        <td class="row-header" (click)="selectWholeRow(i)">
          <span> {{hour}}</span>
        </td>

        <td [ngClass]="{'fixed-color': daypartGrid[i][j]}" id="{{i + '' + j}}" (mouseenter)="changeStyle($event,i,j)"
          (mouseleave)="changeStyle($event,i,j)" (mousedown)="dragDropCellSelection($event, i, j)"
          (mouseup)="dragDropCellSelection($event, i, j)" *ngFor="let c of cells; let j = index">
        </td>
      </tr>
    </tbody>
  </table>
</div>